<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-80 md-xsmall-size-80 mx-auto">
      <simple-wizard>
        <template slot="header">
          <h3 v-if="userID" class="title">Update user</h3>
          <h3 v-if="!userID" class="title">Build user</h3>
          <h5 class="category">
            This information will let us know more about user.
          </h5>
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">
            About
          </template>
          <first-step ref="step1" @on-validated="firstStep"></first-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step2')">
          <template slot="label">
            Account
          </template>
          <second-step ref="step2" @on-validated="secondStep"></second-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>
<script>
import FirstStep from "./UserUpsertSteps/FirstStep.vue";
import SecondStep from "./UserUpsertSteps/SecondStep.vue";
import Swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  data() {
    return {
      wizardModel: {},
      userID: null,
      userInfoID: null,
      // First and second Step data
      first_name: null,
      last_name: null,
      email: null,
      title: null,
      gender: null,
      mobile_phone: null,
      country: null,
      picture: null,
      role: null,
      is_active: false,
      university: null,
      agency: null,
      dorm: null
    };
  },
  components: {
    FirstStep,
    SecondStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    firstStep(validated, model) {
      if (validated) {
        this.picture = this.$refs["step1"].picture;
        this.first_name = this.$refs["step1"].first_name;
        this.last_name = this.$refs["step1"].last_name;
        this.email = this.$refs["step1"].email;
      }
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    getSecondStepData() {
      this.title = this.$refs["step2"].title;
      this.gender = this.$refs["step2"].gender;
      this.mobile_phone = this.$refs["step2"].mobile_phone;
      this.country = this.$refs["step2"].country;
      this.is_active = this.$refs["step2"].is_active;
      this.university = this.$refs["step2"].university;
      this.agency = this.$refs["step2"].agency;
      this.dorm = this.$refs["step2"].dorm;
    },
    secondStep(validated, model) {
      if (validated) {
        var method = "POST";
        this.getSecondStepData();
        let data = {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          title: this.title,
          gender: this.gender,
          mobile_phone: this.mobile_phone,
          country: this.country,
          picture: this.picture,
          role: this.role,
          is_active: this.is_active
        };
        if (this.university) {
          data["university"] = this.university;
        } else if (this.agency) {
          data["agency"] = this.agency;
        } else if (this.dorm) {
          data["dorm"] = this.dorm;
        }
        this.$store
          .upsertBasicUser(method, this.userID, data, this.role)
          .then(response => {
            this.userID = response.data.id;
            this.wizardComplete();
          })
          .catch(error => {
            var message = error.response.data;
            this.$notify({
              message: JSON.stringify(message),
              icon: "add_alert",
              type: "warning",
              verticalAlign: "top",
              timeout: 3000
            });
          });
      }
      this.wizardModel = { ...this.wizardModel, ...model };
      return validated;
    },
    wizardComplete() {
      Swal.fire({
        title: "User created.",
        text: "Finish",
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          if (this.role === 1) {
            this.$router.push({ name: "Admin Users" });
          } else if (this.role === 3) {
            this.$router.push({ name: "Agency Users" });
          } else if (this.role === 4) {
            this.$router.push({ name: "University Users" });
          } else if (this.role === 5) {
            this.$router.push({ name: "Dorm Users" });
          }
        }
      });
    }
  },
  mounted() {
    if (this.$route.meta.staff === "admin") {
      this.role = 1;
    } else if (this.$route.meta.staff === "agency") {
      this.role = 3;
    } else if (this.$route.meta.staff === "university") {
      this.role = 4;
    } else if (this.$route.meta.staff === "dorm") {
      this.role = 5;
    }
  }
};
</script>
